// 等级体系参照  lx
// latest: zhangmyh 2017-3-15 3:18 PM
/* global $ u */
import Collection from 'common/vo/collection'
import 'collection/hierarchy'

function init (refer) {
  // 每次都重新加载
  let collection = Collection.create('collection.hierarchy')
  let enterpriseId = refer.options.enterpriseId || window.global.user.enterpriseId
  collection.load({ enterpriseId: enterpriseId, pageSize: 10 })

  let vm = {
    config: {
      id: 'hierarchy_grid',
      data: collection,
      type: 'grid',
      multiSelect: false,
      editable: false,
      pagination: true,
      fields: [{
        'field': 'code',
        'dataType': 'String',
        'title': '编码',
        'width': '45%'
      }, {
        'field': 'name',
        'dataType': 'String',
        'title': '等级体系名称',
        'width': '45%'
      }]
    }
  }

  let app = u.createApp()
  app.init(vm, $('#hierarchyrefer')[0])

  // 提交事件
  refer.registerSubmitFunc(() => {
    let selectData = collection.datatable.getCurrentRow().data
    return {
      id: selectData.id.value,
      name: selectData.name.value,
      std: selectData.scoreStd.value
    }
  })

  collection.datatable.on('select', function (obj) {
    refer.submit()
  })
}
let template = require('./index.html')
export default {
  init,
  template
}



// WEBPACK FOOTER //
// ./src/components/modalrefer/hierarchy/mainGrid/index.js